<sc-flex fitHeight vertical stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.ui.transport.registration.title"></sc-dictionary-label>
  </sc-dialog-title>
  <div class="stepper-title-bar" *ngIf="this.registration!= null && this.registration.transport != null">
    <div class="title-part" *ngFor="let st of stepperModel.componentTitles; let i = index">
      <div class="divider" *ngIf="i>0">></div>
      <div class="step-title"
        [ngClass]="{'active': stepperModel.currentComponentIndex >= i, 'disabled': i==2 && this.registration.transport.masterdata.managementLevel === TransportManagementLevel.LIFECYCLE}">
        <sc-dictionary-label [dictionaryKey]="st"></sc-dictionary-label>
      </div>
    </div>
  </div>
  <sc-flex-fitting-content vertical>
    <ng-container *ngIf="registration">
      <app-master-data [readonly]="readonly" [registration]="registration" [stepperModel]="stepperModel"
        *ngIf="this.stepperModel.currentComponentIndex === 0" (valueChange)="handleValueChange()"></app-master-data>

      <app-transport-options [registration]="registration" [stepperModel]="stepperModel"
        *ngIf="this.stepperModel.currentComponentIndex === 1"></app-transport-options>

      <app-route [registration]="registration" [stepperModel]="stepperModel"
        *ngIf="this.stepperModel.currentComponentIndex === 2"></app-route>

      <app-supplementary-equipment [registration]="registration" [stepperModel]="stepperModel"
        *ngIf="this.stepperModel.currentComponentIndex === 3"></app-supplementary-equipment>
    </ng-container>
  </sc-flex-fitting-content>
  <div class="messages">
    <app-service-response [responseMessages]="responseMessages"></app-service-response>
  </div>
  <sc-padding [formGroup]="formGroup">
    <sc-flex>
      <sc-back-button dictionaryKey="tmc-yard.common.action.previous" (click)="showPreviousStep()" [disabled]="showPreviousStepDisabled()"
      *ngIf="isPreviousStepVisible()"></sc-back-button>
      <ng-container *ngIf="this.stepperModel.currentComponentIndex === 0">
        <sc-content-spacer grow></sc-content-spacer>
        <sc-checkbox-field formControlName="registerArrival" labelDictionaryKey="tmc-yard.ui.transport-registration.checkbox.register-arrival"></sc-checkbox-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-checkbox-field formControlName="registerEntrance" labelDictionaryKey="tmc-yard.ui.transport-registration.checkbox.register-entrance"></sc-checkbox-field>
      </ng-container>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" [disabled]="isCancelDisabled()" class="cancel-button"
      (click)="cancel()"></sc-cancel-button>
      <ng-container *ngIf="showNextStepButtonVisible()">
        <sc-content-spacer></sc-content-spacer>
        <sc-forward-button iconPosition="right" dictionaryKey="tmc-yard.common.action.next" primary (click)="showNextStep()" [disabled]="showNextStepDisabled()"
        class="confirm-button"></sc-forward-button>
      </ng-container>
      <ng-container *ngIf="showFinishButtonVisible()">
        <sc-content-spacer></sc-content-spacer>
        <sc-save-button dictionaryKey="tmc-yard.ui.transport.registration.action.finish" primary class="confirm-button" (click)="finish()" [disabled]="finishDisabled()"></sc-save-button>
      </ng-container>
    </sc-flex>
  </sc-padding>
</sc-flex>
